import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStatusPageDetailsRoute: InvariantJiraRoute = {
	name: 'communications-status-page-details',
	path: '/jira/communications/status-page/:pageId',
};
